const LangEgiftHeader = {
	navbar: {
		// items: ["item1", "item2", "item3", "item4", "item5", "item6", "item7"],
		items: ["item1", "item2", "item3", "item4", "item5", "item6"],
		item1: {
			path: [
				"https://en.starbucks.vn/coffee",
				"https://www.starbucks.vn/c%C3%A0-ph%C3%AA",
			],
			text: ["COFFEE", "CÀ PHÊ"],
		},
		item2: {
			path: [
				"https://en.starbucks.vn/menu-list",
				"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n",
			],
			text: ["MENU", "THỰC ĐƠN"],
		},
		item3: {
			path: [
				"https://en.starbucks.vn/coffeehouse",
				"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA",
			],
			text: ["COFFEE HOUSE", "QUÁN CÀ PHÊ"],
		},
		item4: {
			path: [
				"https://en.starbucks.vn/responsibility",
				"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m",
			],
			text: ["RESPONSIBILITY", "TRÁCH NHIỆM"],
		},
		item5: {
			path: [
				"https://en.starbucks.vn/about-us",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i",
			],
			text: ["ABOUT US", "VỀ CHÚNG TÔI"],
		},
		item6: {
			path: ["https://card.starbucks.vn/en/", "https://card.starbucks.vn/vi/"],
			text: ["CARD", "THẺ"],
		},
		// item7: {
		// 	path: [
		// 		"https://estore.starbucks.vn/?view=en",
		// 		"https://estore.starbucks.vn/",
		// 	],
		// 	text: ["ESTORE", "ESTORE"],
		// },
		findstore: {
			path: [
				"https://en.starbucks.vn/store-locator",
				"https://www.starbucks.vn/b%E1%BB%99-%C4%91%E1%BB%8Bnh-v%E1%BB%8B-c%E1%BB%ADa-h%C3%A0ng",
			],
			text: ["Find a store", "Tìm cửa hàng"],
		},
	},
}

export default LangEgiftHeader
